module.exports = __webpack_public_path__ + "1d405271e2a194acd719d4bf0e9e220f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_80.jpg
// module id = 1757
// module chunks = 5